import { BaseError } from '../../_base/lang/BaseError';

export class RedepagosBarcodeNotFoundError extends BaseError {}
